// Locale helpers.
//  - getFinalLocale: default-locale fallback (used by i18n/locale.ts).
//  - createDefaultLocaleInfo: build the CoreEnv.localeInfo the SiteFooter expects from
//    webapp-locales getDefaults(), coalescing null/undefined -> '' so getServerSideProps
//    props stay JSON-serializable. Ported from the sibling homepage-webapp
//    (src/utils/localeInfo.ts).

import { getDefaults, getTldLocaleFromRequest } from '@eventbrite/webapp-locales';
import type { IncomingMessage } from 'http';

export const DEFAULT_LOCALE = 'en-US';
export const DEFAULT_LOCALE_UNDERSCORE = 'en_US';

export function getFinalLocale(locale?: string): string {
    return locale || DEFAULT_LOCALE;
}

export function createDefaultLocaleInfo(req?: IncomingMessage): Record<string, unknown> {
    const locale = req ? getTldLocaleFromRequest(req) : DEFAULT_LOCALE_UNDERSCORE;
    const defaults = getDefaults(locale) as unknown as Record<string, unknown>;
    return {
        ...defaults,
        contact_us_path: defaults.contact_us_path ?? '',
        contact_us_url: defaults.contact_us_url ?? '',
        sales_contact_landing_page: defaults.sales_contact_landing_page ?? '',
        sales_contact_link_text: defaults.sales_contact_link_text ?? '',
        twitter_page: defaults.twitter_page ?? '',
        facebook_page: defaults.facebook_page ?? '',
        linked_in_page: defaults.linked_in_page ?? '',
        instagram_page: defaults.instagram_page ?? '',
        blog_url: defaults.blog_url ?? '',
        help_center_language: defaults.help_center_language ?? '',
    };
}
